import ModuleMultiSelect from './ModuleMultiSelect';

export default class UserSelect extends ModuleMultiSelect
{
	Type = 'USER';
};

